/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageContent } from '../../models/image-content';

export interface ApiMasterImageContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterImageContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageContent>;
    })
  );
}

apiMasterImageContentGetByIdGet.PATH = '/api/Master/ImageContent/GetById';
